import { useState, useCallback } from 'react';
import type { CustomizationService } from '../../application/services/CustomizationService';
import type { ProductCustomization } from '../../domain/models/ProductCustomization';
import type { CustomizationParams } from '../../domain/interfaces/CustomizationRepository';

export interface UseCustomizationReturn {
  customization: ProductCustomization | null;
  isLoading: boolean;
  applyCustomization: (designId: string, params: CustomizationParams) => Promise<ProductCustomization>;
  setCustomization: (value: ProductCustomization | null) => void;
  resetCustomization: () => void;
}

export function useCustomization(service: CustomizationService): UseCustomizationReturn {
  const [customization, setCustomization] = useState<ProductCustomization | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const applyCustomization = useCallback(
    async (designId: string, params: CustomizationParams) => {
      setIsLoading(true);
      try {
        const result = await service.applyCustomization(designId, params);
        setCustomization(result);
        return result;
      } finally {
        setIsLoading(false);
      }
    },
    [service]
  );

  const resetCustomization = useCallback(() => {
    setCustomization(null);
  }, []);

  return { customization, isLoading, applyCustomization, setCustomization, resetCustomization };
}
